var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIntercomIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 21C20 21 17.3063 19.9566 15.1274 19.1213H5.964C4.88 19.1213 4 18.2021 4 17.0698V5.04975C4 3.91856 4.88 3 5.964 3H18.0354C19.12 3 19.9994 3.918 19.9994 5.05031V15.4026L20 21ZM17.6349 14.2601C17.5921 14.206 17.5383 14.1613 17.4771 14.1287C17.4158 14.0962 17.3483 14.0765 17.2789 14.071C17.2095 14.0654 17.1397 14.0741 17.0739 14.0965C17.008 14.1189 16.9477 14.1545 16.8966 14.2011C16.8794 14.2157 15.1737 15.7091 11.9994 15.7091C8.86457 15.7091 7.13257 14.2264 7.10171 14.1994C7.05056 14.1531 6.9902 14.1177 6.92446 14.0955C6.85871 14.0733 6.78901 14.0647 6.71974 14.0704C6.65047 14.0761 6.58315 14.0958 6.52202 14.1283C6.46089 14.1609 6.40728 14.2056 6.36457 14.2596C6.2731 14.3719 6.22837 14.5142 6.23943 14.6578C6.24909 14.8006 6.31414 14.9344 6.42114 15.0313C6.50229 15.1033 8.44229 16.8032 11.9994 16.8032C15.5571 16.8032 17.4971 15.1033 17.5783 15.0313C17.6851 14.9343 17.7499 14.8006 17.7594 14.6578C17.7705 14.5145 17.726 14.3724 17.6349 14.2601Z",
    fill: "#1A1B1D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIntercomIcon);
export default __webpack_public_path__ + "static/media/intercom-icon.3fbc92bf49b95d4744d7842b9a8236e6.svg";
export { ForwardRef as ReactComponent };